import { Link } from "react-router-dom";
import React from "react";
import "../styles/BPOServices.css";
import bpo1 from "../assets/services/BPO 1.jpeg";
import bpo2 from "../assets/services/BPO 2.jpeg";

const solutions = [
  {
    title: "Customer Support",
    description:
      "Provide responsive customer assistance through structured support processes focused on clear communication and customer satisfaction.",
  },
  {
    title: "Voice Process",
    description:
      "Support customers through professional inbound and outbound calling processes designed around your business requirements.",
  },
  {
    title: "Email & Chat Support",
    description:
      "Handle customer questions and service requests through organized email and chat support workflows.",
  },
  {
    title: "Back Office Operations",
    description:
      "Manage repetitive operational activities, documentation and administrative workflows efficiently.",
  },
  {
    title: "Data Processing",
    description:
      "Support business operations through accurate data entry, verification, organization and processing.",
  },
  {
    title: "Process Management",
    description:
      "Create structured outsourcing workflows that help teams manage everyday business operations effectively.",
  },
];

const process = [
  {
    title: "Understand",
    description:
      "We understand your process, customers, requirements and operational expectations.",
  },
  {
    title: "Plan",
    description:
      "We create a clear workflow with responsibilities, communication methods and quality expectations.",
  },
  {
    title: "Operate",
    description:
      "Our team handles assigned processes using structured and consistent operational practices.",
  },
  {
    title: "Improve",
    description:
      "We review performance and continuously improve processes for better efficiency and service quality.",
  },
];

function BPOServices() {
  return (
    <main className="bpo-page">

      <section className="bpo-hero">
        <div className="bpo-hero-content">
          <span className="bpo-eyebrow">BPO SERVICES</span>

          <h1>
            Smarter Support
            <span> For Everyday Business</span>
          </h1>

          <p>
            Simplify everyday business operations with reliable
            outsourcing services designed to support customers,
            teams and growing organizations.
          </p>

          <a href="#bpo-solutions" className="bpo-primary-btn">
            Explore BPO Services
            <span>→</span>
          </a>
        </div>

        <div className="bpo-hero-visual">
          <div className="bpo-hero-image">
            <img
              src={bpo1}
              alt="Business support team"
            />
          </div>
        </div>
      </section>

      <section className="bpo-intro">
        <div className="bpo-intro-header">
          <div className="bpo-intro-label">
            <span>01</span>
            <p>WHAT WE SUPPORT</p>
          </div>

          <div className="bpo-intro-heading">
            <h2>
              Reliable operations that
              <span> keep your business moving</span>
            </h2>

            <p>
              From customer support and back-office operations
              to data processing and communication, we provide
              structured outsourcing support for everyday business needs.
            </p>
          </div>
        </div>

        <div className="bpo-intro-content">
          <div className="bpo-intro-main">
            <span>OUR APPROACH</span>

            <h3>
              Outsourcing should make your
              <strong> operations simpler</strong>
            </h3>

            <p>
              We focus on organized processes, clear communication
              and consistent service so your internal team can focus
              on higher-priority business activities.
            </p>
          </div>

          <div className="bpo-intro-points">
            <div className="bpo-intro-point">
              <span>01</span>
              <div>
                <h4>Customer focused</h4>
                <p>
                  Maintain professional and responsive communication
                  across customer interactions.
                </p>
              </div>
            </div>

            <div className="bpo-intro-point">
              <span>02</span>
              <div>
                <h4>Process driven</h4>
                <p>
                  Follow structured workflows that keep everyday
                  operations organized and consistent.
                </p>
              </div>
            </div>

            <div className="bpo-intro-point">
              <span>03</span>
              <div>
                <h4>Scalable support</h4>
                <p>
                  Adapt operational support as your business
                  requirements and workload change.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bpo-solutions" id="bpo-solutions">
        <div className="bpo-section-heading">
          <div>
            <span className="bpo-small-label">BPO SERVICES</span>

            <h2>
              Support for your
              <span> everyday operations</span>
            </h2>
          </div>

          <p>
            Outsourcing services designed to help businesses
            manage customer communication and operational work.
          </p>
        </div>

        <div className="bpo-solutions-grid">
          {solutions.map((item) => (
            <article className="bpo-solution-card" key={item.title}>
              <div className="bpo-card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="bpo-tech-section">
        <div className="bpo-tech-content">
          <span className="bpo-small-label">BUSINESS SUPPORT</span>

          <h2>
            Let your team focus
            <span> on what matters</span>
          </h2>

          <p>
            Outsourcing selected business activities can help
            organizations reduce operational pressure and create
            more time for important business priorities.
          </p>

          <div className="bpo-tech-points">
            <div>
              <strong>01</strong>
              <h4>Consistent service</h4>
              <p>
                Maintain organized customer and operational support
                through structured processes.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h4>Better efficiency</h4>
              <p>
                Reduce repetitive workload and improve everyday
                operational efficiency.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h4>Flexible capacity</h4>
              <p>
                Extend your operational capacity when workloads
                or business requirements increase.
              </p>
            </div>
          </div>
        </div>

        <div className="bpo-tech-visual">
          <div className="bpo-tech-image">
            <img
              src={bpo2}
              alt="Professional business team"
            />
          </div>
        </div>
      </section>

      <section className="bpo-process">
        <div className="bpo-process-heading">
          <span className="bpo-small-label">HOW WE WORK</span>

          <h2>
            Simple processes.
            <span> Reliable support</span>
          </h2>

          <p>
            We create structured workflows that keep outsourced
            operations clear, organized and measurable.
          </p>
        </div>

        <div className="bpo-process-grid">
          {process.map((item, index) => (
            <article className="bpo-process-item" key={item.title}>
              <div className="bpo-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="bpo-final">
        <div className="bpo-final-content">
          <div className="bpo-final-main">
            <div className="bpo-final-label">
              <span></span>
              SIMPLIFY YOUR OPERATIONS
            </div>

            <h2>
              Build a support system
              <span> that works for you</span>
            </h2>

            <p>
              Tell us about the processes you want to outsource.
              We can help you explore a practical support model
              for your business.
            </p>
          </div>

          <div className="bpo-final-action">
            <div className="bpo-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>
              <p>People · Process · Support</p>
            </div>

            <Link
              to="/contact"
              className="bpo-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default BPOServices;